import * as actions from './actions';

const initialState = {
  // Task Alerts
  taskAlerts: [],
  taskAlertDetail: null,
  taskAlertSummary: {
    pending: 0,
    overdue: 0,
    completed: 0,
    upcoming_7_days: 0,
  },
  upcomingAlerts: [],

  // Alert Templates
  alertTemplates: [],
  alertTemplateDetail: null,
  generalTemplates: [],

  // Loading states
  loading: false,
  loadingDetail: false,
  loadingSummary: false,
  loadingUpcoming: false,
  loadingTemplates: false,

  // Error states
  error: null,
  errorDetail: null,
  errorSummary: null,
  errorUpcoming: null,
  errorTemplates: null,

  // UI State
  filters: {
    status: 'all',
    priority: null,
    growth_stage: null,
    active_only: true,
  },
};

const taskAlertsReducer = (state = initialState, action) => {
  switch (action.type) {
    // ==================== FETCH TASK ALERTS ====================

    case actions.FETCH_TASK_ALERTS.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actions.FETCH_TASK_ALERTS.SUCCESS:
      return {
        ...state,
        loading: false,
        taskAlerts: action.payload,
        error: null,
      };

    case actions.FETCH_TASK_ALERTS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ==================== FETCH TASK ALERT DETAIL ====================

    case actions.FETCH_TASK_ALERT_DETAIL.REQUEST:
      return {
        ...state,
        loadingDetail: true,
        errorDetail: null,
      };

    case actions.FETCH_TASK_ALERT_DETAIL.SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        taskAlertDetail: action.payload,
        errorDetail: null,
      };

    case actions.FETCH_TASK_ALERT_DETAIL.FAILURE:
      return {
        ...state,
        loadingDetail: false,
        errorDetail: action.payload,
      };

    // ==================== FETCH SUMMARY ====================

    case actions.FETCH_TASK_ALERT_SUMMARY.REQUEST:
      return {
        ...state,
        loadingSummary: true,
        errorSummary: null,
      };

    case actions.FETCH_TASK_ALERT_SUMMARY.SUCCESS:
      return {
        ...state,
        loadingSummary: false,
        taskAlertSummary: action.payload,
        errorSummary: null,
      };

    case actions.FETCH_TASK_ALERT_SUMMARY.FAILURE:
      return {
        ...state,
        loadingSummary: false,
        errorSummary: action.payload,
      };

    // ==================== FETCH UPCOMING ====================

    case actions.FETCH_UPCOMING_TASK_ALERTS.REQUEST:
      return {
        ...state,
        loadingUpcoming: true,
        errorUpcoming: null,
      };

    case actions.FETCH_UPCOMING_TASK_ALERTS.SUCCESS:
      return {
        ...state,
        loadingUpcoming: false,
        upcomingAlerts: action.payload,
        errorUpcoming: null,
      };

    case actions.FETCH_UPCOMING_TASK_ALERTS.FAILURE:
      return {
        ...state,
        loadingUpcoming: false,
        errorUpcoming: action.payload,
      };

    // ==================== CREATE TASK ALERT ====================

    case actions.CREATE_TASK_ALERT.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actions.CREATE_TASK_ALERT.SUCCESS:
      return {
        ...state,
        loading: false,
        taskAlerts: [action.payload, ...state.taskAlerts],
        error: null,
      };

    case actions.CREATE_TASK_ALERT.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ==================== UPDATE TASK ALERT ====================

    case actions.UPDATE_TASK_ALERT.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actions.UPDATE_TASK_ALERT.SUCCESS:
      return {
        ...state,
        loading: false,
        taskAlerts: state.taskAlerts.map((alert) =>
          alert.id === action.payload.id ? action.payload : alert
        ),
        taskAlertDetail: state.taskAlertDetail?.id === action.payload.id
          ? action.payload
          : state.taskAlertDetail,
        error: null,
      };

    case actions.UPDATE_TASK_ALERT.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ==================== DELETE TASK ALERT ====================

    case actions.DELETE_TASK_ALERT.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actions.DELETE_TASK_ALERT.SUCCESS:
      return {
        ...state,
        loading: false,
        taskAlerts: state.taskAlerts.filter((alert) => alert.id !== action.payload.alertId),
        taskAlertDetail: state.taskAlertDetail?.id === action.payload.alertId
          ? null
          : state.taskAlertDetail,
        error: null,
      };

    case actions.DELETE_TASK_ALERT.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ==================== COMPLETE TASK ALERT ====================

    case actions.COMPLETE_TASK_ALERT.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actions.COMPLETE_TASK_ALERT.SUCCESS:
      return {
        ...state,
        loading: false,
        taskAlerts: state.taskAlerts.map((alert) =>
          alert.id === action.payload.id ? action.payload : alert
        ),
        taskAlertDetail: state.taskAlertDetail?.id === action.payload.id
          ? action.payload
          : state.taskAlertDetail,
        error: null,
      };

    case actions.COMPLETE_TASK_ALERT.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ==================== DISMISS TASK ALERT ====================

    case actions.DISMISS_TASK_ALERT.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actions.DISMISS_TASK_ALERT.SUCCESS:
      return {
        ...state,
        loading: false,
        taskAlerts: state.taskAlerts.map((alert) =>
          alert.id === action.payload.id ? action.payload : alert
        ),
        taskAlertDetail: state.taskAlertDetail?.id === action.payload.id
          ? action.payload
          : state.taskAlertDetail,
        error: null,
      };

    case actions.DISMISS_TASK_ALERT.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ==================== REOPEN TASK ALERT ====================

    case actions.REOPEN_TASK_ALERT.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actions.REOPEN_TASK_ALERT.SUCCESS:
      return {
        ...state,
        loading: false,
        taskAlerts: state.taskAlerts.map((alert) =>
          alert.id === action.payload.id ? action.payload : alert
        ),
        taskAlertDetail: state.taskAlertDetail?.id === action.payload.id
          ? action.payload
          : state.taskAlertDetail,
        error: null,
      };

    case actions.REOPEN_TASK_ALERT.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ==================== ALERT TEMPLATES ====================

    case actions.FETCH_ALERT_TEMPLATES.REQUEST:
      return {
        ...state,
        loadingTemplates: true,
        errorTemplates: null,
      };

    case actions.FETCH_ALERT_TEMPLATES.SUCCESS:
      return {
        ...state,
        loadingTemplates: false,
        alertTemplates: action.payload,
        errorTemplates: null,
      };

    case actions.FETCH_ALERT_TEMPLATES.FAILURE:
      return {
        ...state,
        loadingTemplates: false,
        errorTemplates: action.payload,
      };

    case actions.FETCH_GENERAL_TEMPLATES.SUCCESS:
      return {
        ...state,
        generalTemplates: action.payload,
      };

    // ==================== UI STATE ====================

    case actions.SET_TASK_ALERT_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };

    case actions.CLEAR_TASK_ALERT_DETAIL:
      return {
        ...state,
        taskAlertDetail: null,
        errorDetail: null,
      };

    default:
      return state;
  }
};

export default taskAlertsReducer;
